module.exports = __webpack_public_path__ + "static/img/02.6ecd3fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/190419/02.png
// module id = vc/O
// module chunks = 0